<script setup>
import i18n from "@/i18n"
import { ref, onMounted, provide } from "vue"
import formCom1 from "./components/form1.vue" // 表单信息1
import formCom2 from "./components/form2.vue" //表单信息2
import { showMessage } from "@/utils/hooks/message"
import { perfect_information, perfect_information_user_v3, register_v3 } from "@/service/index"
import completeSvg from "@/assets/images/login/complete.svg"
import infoSvg from "@/assets/images/account/info.svg"
import { useRouter, useRoute } from "vue-router"
import Swal from "sweetalert2";
import { getLangValue } from "@/utils/common"; //获取后端语言
import { getLangData } from "@/service/apiList/lang.js"
const formData = ref({})
const showIndex = ref(1)  // 0-未添加信息  1-表单信息  2-审核中信息  3-审核失败信息  4-审核成功 展示自己的信息
const showBarIndex = ref(0)
const detailInfo = ref({})
const router = useRouter()
const route = useRoute()
const companytype = ref('')
const contact_address = ref([])
provide('detailInfo', detailInfo)
provide('company_type', companytype)
const nextStep = async (formData1) => {
    if (showBarIndex.value == 0) {
        formData.value = formData1[0]
        companytype.value = formData1[0].companyType
        // console.log(formData1);
        // contact_address.value = formData1[1];
        showBarIndex.value++
    } else if (showBarIndex.value == 1) {
        // 提交信息
        console.log(formData1);
        contact_address.value = formData1[2];
        // console.log(formData.value);
        let params = {
            company_name: formData.value.companyNmae, //公司名称
            company_logo: formData1[0].logo.length ? formData1[0].logo.map(item => item.id)[0] : '',
            company_type: formData.value.companyType.join(','), // 企业类型
            contact_first_name: formData.value.xing, //联系人姓
            contact_last_name: formData.value.name, // 联系人名
            contact_name: formData.value.name + formData.value.xing, //全名
            contact_email: formData.value.email, // 联系人邮箱
            landline_number: formData.value.phone, // 座机号码
            mobile_phone_number: formData.value.phone_number, // 手机号码
            // certification_company: formData.value.is_certification_company, // 是否第三方认证公司
            // testing_company: formData.value.testing_company, // 是否检测机构
            business_scope: formData.value.main_business_areas, //经营范围
            place_of_incorporation: formData1[0].Enterprise_registered_countryKey, //公司注册地
            certificate_number: formData1[0].Certificate_No, //证书编号
            company_qualification: formData1[0].qualification_documents.map(item => item.id), //公司资质
            // Enterprise_registered_country: formData1[0].Enterprise_registered_country, // 企业注册地址国家
            landline_number_area: formData.value.phoneCountry, // 联系人座机 国家
            mobile_phone_number_area: formData.value.phone_numberCountry, // 联系人手机国家
            //新增字段
            company_qualification_validity_period: formData1[0].company_qualification_validity_period,
            company_qualification_certification_body: formData1[0].company_qualification_certification_body,
            company_website: formData1[0].company_website,
            company_address: formData1[1].filter(item => item.country).map(item => {
                return {
                    id: item.id,
                    name: item.country, //简称
                    country: item.countryKey, //国家
                    province: item.province, //省
                    province_code: item.province_code, //省
                    city: item.city, //市
                    address1: item.address, //详情地址1
                    address2: '', //详情地址2
                    address3: '', //详情地址3
                    postcode: item.post, //邮编
                }
            }), // 生产地址
            contact_address: contact_address.value.map(item => {
                return {
                    id: item.id,
                    name: item.country, //简称
                    country: item.countryKey, //国家
                    province: item.province, //省
                    city: item.city, //市
                    address1: item.address, //详情地址1
                    address2: '', //详情地址2
                    address3: '', //详情地址3
                    postcode: item.post, //邮编
                }
            }) // 企业通讯地址
        }
        // console.log(params);
        // 先注册  没有token说明 没有注册  有token说明注册成功但是信息审核不通过 需再次提交
        let username = sessionStorage.getItem("username")
        let password = sessionStorage.getItem("password")
        if (!route.query.token && username && password && route.query.vcode) {
            params.username = username
            params.password = password
            params.vcode = route.query.vcode
            let url = window.location.href
            let arr = url.split('/#/')
            let website = arr[0]
            params.website = website
            params.perfect_information_url = `${website}/#/account_business_information`
            let xx = true
            if (xx) {
                const resp = await register_v3(params);
                if (resp.code == 0) {
                    // 注册完毕之后  提交完善信息
                    // showMessage('success', resp.message)
                    showIndex.value = 2
                } else {
                    showMessage('danger', resp.message)
                }
            }

        } else {
            // console.log(params);
            let user_id = route.query.token
            let x = true
            if (x) {
                let url = window.location.href
                let arr = url.split('/#/')
                let website = arr[0]
                params.website = website
                params.perfect_information_url = `${website}/#/account_business_information`
                const resp = await perfect_information(user_id, params);
                if (resp) {
                    if (resp.code == 0) {
                        // showMessage('success', resp.message)
                        // showBarIndex.value++
                        // showIndex.value = 2
                        //查询详情状态
                        getStatusFun()
                    } else {
                        showMessage('danger', resp.message)
                    }
                }
            }
        }
    }
}
const backStep = () => {
    if (showBarIndex.value > 0) {
        showBarIndex.value--
    }
}

const getStatusFun = async () => {
    // 是否有数据在审核  有的话就在第三步   没有的话就在默认的第一步  失败的话在第4步  第4步可以重新提交信息
    // let status = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).status : ''
    // 0-未审核-待完善资料  1-审核通过  2待审核-已完善资料  3待审核-更新除联系人/手机号码/公司邮箱/联系人邮箱/座机号码 4审核完善资料-未通过  5 审核更新资料-未通过
    if (route.query.token) {
        // let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
        let token = route.query.token
        const resp = await perfect_information_user_v3({ token: token });
        detailInfo.value = resp.payload
        let status = '' //设置状态
        if (resp.code == 0) {
            if (resp.payload && resp.payload.status)
                status = resp.payload.status
        } else {
            showMessage('danger', resp.message)
            return
        }
        // 显示数据
        if (status == 0) {
            showIndex.value = 1
        } else if (status == 1) {
            showIndex.value = 4
        } else if (status == 2) {
            showIndex.value = 2
        } else if (status == 4) {
            showIndex.value = 3
        }
        // 将token存进缓存
        sessionStorage.setItem('set_menu_list', JSON.stringify({ "token": route.query.token }))
    }
    // }

}
const goLogin = () => {
    router.push({ path: '/login' })
}

const showReason = () => {
    /**显示原因 */
    if (detailInfo.value.review_log && detailInfo.value.review_log.length) {
        // console.log(detailInfo.value.review_log);
        let obj = [...detailInfo.value.review_log].pop()
        // detailInfo.value.examine_info = obj.description ? obj.description : ''
        Swal.fire({
            width: '500px',
            html: `<div>
            <div class='my-title my-2' style='font-size:16px; font-weight:bold'>${getLangValue('my.account', 'rejectReason')}</div>
            <div style='text-align:left;line-height:22px;min-height:100px'>
            ${obj.description ? obj.description : ''}
            </div>
        </div>`,
            showConfirmButton: true,
            confirmButtonText: getLangValue('login.agreeAndContinue'),
            confirmButtonColor: '#0AB39C',
        });
    }
}
const chineseClick = () => {
    const language = "ch";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
const englishClick = () => {
    const language = "en";
    sessionStorage.setItem("language", language);
    i18n.global.locale = language;
}
const goComplete = async () => {
    // 获取详细信息
    // let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
    // const resp = await perfect_information_user_v3(user_id);
    // if (resp) {
    // detailInfo.value = resp.payload
    showIndex.value = 1
    // }
}
const _getLangData = async () => {
    // 获取语言JSON数据
    const reps = await getLangData();
    if (reps.code === 0) {
        sessionStorage.setItem("custom-lang", JSON.stringify(reps.payload));
    }
}
onMounted(async () => {
    let obj = sessionStorage.getItem("custom-lang",)
    if (typeof obj == 'undefined' || obj == '' || obj == null) {
        await _getLangData();
        window.location.reload();
    }
    // 初始状态
    getStatusFun();
})
</script>
<template>
    <div style="overflow-x: auto; overflow-y: hidden; height: 100vh">
        <!-- 中英文切换 -->
        <div
            style="position: fixed; right: 20px; top: 40px; width: 200px; text-align: center; transform:translateX(-50%) ;">
            <span @click="chineseClick" class="cursor-pointer">
                {{ getLangValue('base.chinese') }}
            </span> | <span @click="englishClick" class="cursor-pointer">
                {{ getLangValue('base.english') }}
            </span>
        </div>
        <div class="w-100 h-100 bg-white" v-show="showIndex == 0">
            <div class="d-flex align-items-center justify-content-center h-100"
                style="font-size: 16px; flex-direction: column;">
                {{ getLangValue('my.account', 'info') }}
                <div style="text-align: center;color: #0AB39C;text-decoration:underline">
                    <span class="p-1 cursor-pointer" @click="showIndex = 1">{{ getLangValue('my.account', 'info1')
                        }}</span>
                </div>
            </div>
        </div>
        <div class="w-100 h-100 bg-white py-8 my-scroll-bar" v-show="showIndex == 1" style="overflow-y: auto;">
            <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                <div style="width: 958px; height: 750px;">
                    <div class="progressbar d-flex align-items-center" style="height: 58px;">
                        <div class="flex-1 d-flex align-items-center">
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 40px; height: 40px; background-color: #9599AD; border-radius: 50%;">
                                <i style="font-size: 24px; color: white;" class=" ri-arrow-left-s-line"></i>
                            </div>
                            <hr style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                        </div>
                        <div class="flex-1" style="position: relative;">
                            <div>
                                <div class="d-flex align-items-center" style="height: 40px;">
                                    <div class="d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px; ">
                                        <div :class="showBarIndex == 0 ? 'active' : ''"
                                            style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                            1
                                        </div>
                                        <div
                                            style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                            {{ getLangValue('my.account', 'progressInfo1') }}</div>
                                    </div>
                                    <hr
                                        style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                                </div>
                            </div>

                        </div>
                        <div class="flex-1" style="position: relative;">
                            <div>
                                <div class="d-flex align-items-center" style="height: 40px;">
                                    <div class="d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px; ">
                                        <div :class="showBarIndex == 1 ? 'active' : ''"
                                            style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                            2
                                        </div>
                                        <div
                                            style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                            {{ getLangValue('my.account', 'progressInfo2') }}</div>
                                    </div>
                                    <hr
                                        style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-1" style="position: relative;">
                            <div>
                                <div class="d-flex align-items-center" style="height: 40px;">
                                    <div class="d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px; ">
                                        <div :class="showBarIndex == 2 ? 'active' : ''"
                                            style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                            3
                                        </div>
                                        <div
                                            style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                            {{ getLangValue('my.account', 'progressInfo3') }}</div>
                                    </div>
                                    <hr
                                        style="width: calc(100% - 40px); border: 2px solid #212529 !important; opacity: 1;" />
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 40px; height: 40px; background-color: #9599AD; border-radius: 50%;">
                                <i style="font-size: 24px; color: white;" class=" ri-arrow-right-s-line"></i>
                            </div>
                        </div>
                    </div>
                    <!-- 表单部分 -->
                    <formCom1 @nextStep="nextStep" v-show="showBarIndex == 0" />
                    <formCom2 @nextStep="nextStep" v-show="showBarIndex == 1" @backStep="backStep" />
                </div>
            </div>
        </div>
        <div class="w-100 h-100 bg-white py-8 my-scroll-bar" v-show="showIndex == 2" style="overflow-y: auto;">
            <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                <div style="width: 958px; height: 750px;">
                    <div class="d-flex align-items-center justify-content-center" style="height: calc(100% - 58px);">
                        <div>
                            <div class="mb-3 " style="width: 96px; margin: 0 auto;">
                                <img :src="completeSvg" width="96" />
                            </div>
                            <div style="text-align: center; margin: 20px 0 40px 0;">
                                {{ getLangValue('my.account', 'progressInfo4') }}
                            </div>
                            <div style="text-align: center; margin: 20px 0 0px 0;">
                                <b-button class="mx-2" variant="success" @click="goLogin"
                                    style="min-width: 104px;height: 38px;">
                                    {{ getLangValue('my.account', 'backToLogin') }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 h-100 bg-white py-8 my-scroll-bar" v-show="showIndex == 3" style="overflow-y: auto;">
            <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                <div style="width: 958px; height: 750px;">
                    <div class="d-flex align-items-center justify-content-center" style="height: calc(100% - 58px);">
                        <div>
                            <div class="mb-3 " style="width: 96px; margin: 0px auto;">
                                <img :src="infoSvg" width="96" />
                            </div>
                            <div style="text-align: center; margin: 20px 0 60px 0;">
                                {{ getLangValue('my.account', 'progressInfo5') }}
                                <a style="text-decoration: underline !important; color: red;cursor: pointer;"
                                    @click="showReason">{{ getLangValue('base.to_view') }}{{
                                        getLangValue('my.account', 'rejectReason') }}</a>
                            </div>
                            <div style="text-align: center; margin: 20px 0 0px 0;">
                                <b-button class="mx-2" variant="success" @click="goComplete"
                                    style="min-width: 104px;height: 38px;">
                                    {{ getLangValue('my.account', 'btn_complete') }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 h-100 bg-white py-8 my-scroll-bar" v-show="showIndex == 4" style="overflow-y: auto;">
            <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                <div style="width: 958px; height: 750px;">
                    <div class="d-flex align-items-center justify-content-center" style="height: calc(100% - 58px);">
                        <div>
                            <div class="mb-3 " style="width: 96px; margin: 0px auto;">
                                <img :src="completeSvg" width="96" />
                            </div>
                            <div style="text-align: center; margin: 20px 0 40px 0;">
                                {{ getLangValue('my.account', 'progressInfo6') }}
                            </div>
                            <div style="text-align: center; margin: 20px 0 0px 0;">
                                <b-button class="mx-2" variant="success" @click="goLogin"
                                    style="min-width: 104px;height: 38px;">
                                    {{ getLangValue('login.login') }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.active {
    background-color: #0AB39C !important;
}

.form-control {
    color: #888a97;
}
</style>